export const inputCls =
  "w-full rounded-[3px] bg-black border border-zinc-800 px-3 py-2 text-sm outline-none focus:border-yellow-400 transition-colors";

export const Field = ({ label, children, hint }) => (
  <label className="block space-y-1.5">
    <span className="mono-label">{label}</span>
    {children}
    {hint && <span className="block text-xs text-zinc-500">{hint}</span>}
  </label>
);

export const Sel = ({ value, onChange, options, testId, placeholder }) => (
  <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={inputCls}>
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);
